import React, { memo, useEffect, useCallback, useState} from 'react';
import EdgeHelper from "components/messaging/EdgeHelper.js";
import MessagingEdges from 'components/messaging/MessagingEdges.js';
import AllEdges from "components/pulled/AllEdges.js";
import {useKeyShortcuts} from './useKeyShortcuts.js';
import {useEffectKeys} from './useEffectKeys.js';
import {getPath} from "components/effects/rack/getPath.js"
import Arrow from "components/effects/rack/Arrow.js";
import {
    setBulkWindowPositions,
    setSelectedPadEdge,
    setDrawingPadEdge,
    setMovingPadEdge,
       } from 'actions/index.js';
import {connect} from 'react-redux';

const GlobalEdges = memo(({
    setMovingPadEdge,
    movingEdge,
    edgesRef,
    effects,
    midiEffects,
    subSequence,
    drawingEdge,
    scale,
    setWindowPositions,
    setDrawingPadEdge,
    setSelectedPadEdge,
    ...props
}) => { 
    let x1,x2,y1,y2;

    useKeyShortcuts({subSequence, setWindowPositions}); 
    if (drawingEdge) {
        x1 = drawingEdge.x1 / (window._scale || 1);
        y1 = drawingEdge.y1 / (window._scale || 1);
        x2 = drawingEdge.x2 / (window._scale || 1);
        y2 = drawingEdge.y2 / (window._scale || 1);
    }
    useEffectKeys({subSequence, setSelectedPadEdge});

    useEffect(() => {
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
        return () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [subSequence]);

    const onMouseMove = useCallback((e) => {
        let {sequencerEngine} = subSequence;
        let {state} = sequencerEngine;
        let {movingEdge, drawingEdges} = state.pads;

        if (movingEdge) {
            let rect = props.containerRef.current.getBoundingClientRect();
            let x = e.clientX;// - rect.left + props.containerRef.current.scrollLeft;
            let y = e.clientY; //- rect.top + props.containerRef.current.scrollTop;
            setMovingPadEdge({
                ... movingEdge,
                x2: x,
                y2: y,
            });
        }

        if (drawingEdges[subSequence.id]) {
            let rect = props.containerRef.current.getBoundingClientRect();
            let x = e.clientX;// - rect.left + props.containerRef.current.scrollLeft;
            let y = e.clientY; //- rect.top + props.containerRef.current.scrollTop;
            let {editorPadding} = state.spatial;
            setDrawingPadEdge(
                subSequence.id,
                {
                ... drawingEdges[subSequence.id],
                    x2: x, 
                    y2: y 
            });
        }
    }, [subSequence]);

    const onMouseUp = useCallback((e) => {
        setDrawingPadEdge(subSequence.id, undefined);
        setMovingPadEdge(undefined);
    }, [subSequence]);

    let style = {
        transform: 'scale('+ (1/scale) + ')'
    };

    if (props.scrollable && props.containerRef.current) {
        style.width = props.containerRef.current.scrollWidth + "px";
        style.height = props.containerRef.current.scrollHeight + "px";
    } 

    if (edgesRef.current) {
        let rect = edgesRef.current.getBoundingClientRect();
        x1 -= rect.left
        x2 -= rect.left;
        y1 -= rect.top;
        y2 -= rect.top;

        if (movingEdge) {
            movingEdge = {... movingEdge};
            //movingEdge.x1 -= rect.left;
            //movingEdge.y1 -= rect.top;
            movingEdge.x2 -= rect.left;
            movingEdge.y2 -= rect.top;
        }
    }

    return (<svg
              ref={edgesRef}
              onMouseDown={(e) => setSelectedPadEdge(undefined)}
              style={style} className="edges-drawer">
              <marker id="arrowhead" markerWidth="10" markerHeight="8" 
	              refX="4" refY="2" orient="auto">
                <polygon points="0 0, 5 2, 0 4" />
              </marker>
              {drawingEdge && <Arrow className="pad-effect-edge drawing-edge" points={
                  getPath(x1,y1,x2,y2)}/>}
              {movingEdge && <Arrow className="pad-effect-edge drawing-edge" points={
                  getPath(movingEdge.x1,movingEdge.y1,movingEdge.x2,movingEdge.y2)}/>}
              {movingEdge && <EdgeHelper
                               edge={movingEdge}
                               pathPoints={getPath(movingEdge.x1,movingEdge.y1,movingEdge.x2,movingEdge.y2)}/>}
              <MessagingEdges
                selection={props.selection}
                containerRef={props.containerRef}
                           edgesRef={edgesRef}
                subSequence={subSequence}/>
              {subSequence.tracks && subSequence.tracks
               .filter(t => t.effectRack && t.zObject && t.zObject.name === "track") 
               .map(
                  pad => <AllEdges
                           key={pad.id}
                           effects={midiEffects[pad.id]}
                           scale={scale}
                           edgesRef={edgesRef}
                           isMidi={true}
                           fromId={pad.sequencer ? pad.sequencer.id : pad.id}
                           outputPrefix="effect-output-"
                           pad={pad}
                           {...props}
                         />)}
              {subSequence.zObjects.filter(x => x.name === "pad")
               .filter(x => x.effect.pad)
               .map(x => x.effect.pad)
               .map(
                  pad => <AllEdges
                           key={pad.id}
                           edgesRef={edgesRef}
                           effects={effects[pad.id]}
                           scale={scale}
                           pad={pad} {...props}/>)}
            </svg>
           );
});

const mapStateToProps = (state, props) => {
  return {
      drawingEdge: state.pads.drawingEdges[props.subSequence.id],
      movingEdge: state.pads.movingEdge,
      effects: state.pads.padEffects,
      midiEffects: state.pads.trackMidiEffects,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedPadEdge: x=>dispatch(setSelectedPadEdge(x)),
      setDrawingPadEdge: (x,y)=>dispatch(setDrawingPadEdge(x,y)),
      setMovingPadEdge: (x)=>dispatch(setMovingPadEdge(x)),
      setWindowPositions: (pos)=>dispatch(setBulkWindowPositions(pos))     
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalEdges);
